import { render, staticRenderFns } from "./SettingsGroup.vue?vue&type=template&id=d0afa110&scoped=true&"
import script from "./SettingsGroup.vue?vue&type=script&lang=js&"
export * from "./SettingsGroup.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGroup.vue?vue&type=style&index=0&id=d0afa110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0afa110",
  null
  
)

export default component.exports